"use strict";
exports.__esModule = true;
exports.SELF_PAY_TRACKER_STEPS = exports.SLC_CLASSIC_TRACKER_STEPS = exports.CLASSIC_TRACKER_STEPS = exports.CLASSIC_NO_RENT_POSTED = exports.FLEX_ANYWHERE_COVERED = exports.FLEX_ANYWHERE_RENT_PAID = exports.FA_PAYMENT_METHOD_STATUS = exports.FLEX_ANYWHERE_SUBMIT_RENT = exports.FLEX_ANYWHERE_GET_READY_AFTER_BP = exports.FLEX_ANYWHERE_GET_READY_BEFORE_BP = exports.CLASSIC_FAILED_PAYMENT = exports.CLASSIC_NOT_COVERED = exports.CLASSIC_COVERED = exports.CLASSIC_RENT_PAID = exports.AUTOPILOT_BILL_READY = exports.AUTOPILOT_GET_READY = exports.CLASSIC_RENT_PROCESSING = exports.CLASSIC_GET_READY = void 0;
exports.CLASSIC_GET_READY = {
    MAIN_TEXT: 'Your 1st payment of {{firstPaymentAmount}} (estimated) {{daysUntilBpStarts}}',
    SUB_TEXT: 'Once we receive your 1st payment, we’ll submit your rent to your property.'
};
exports.CLASSIC_RENT_PROCESSING = {
    MAIN_TEXT: "Rent submitted to your property",
    SUB_TEXT: 'For the latest status update, check your property’s portal.'
};
exports.AUTOPILOT_GET_READY = {
    MAIN_TEXT: 'Waiting for your rent bill',
    SUB_TEXT: "We'll let you know when your property has posted your bill so you can make your 1st payment."
};
exports.AUTOPILOT_BILL_READY = {
    MAIN_TEXT: 'Ready to pay your rent?',
    SUB_TEXT: "Your rent bill has posted! Make your 1st payment now, then Flex will submit your full rent to your property.",
    CTA: 'Make 1st payment'
};
exports.CLASSIC_RENT_PAID = {
    MAIN_TEXT: 'Your rent has been paid!',
    SUB_TEXT: "Your next payment of {{amount}} {{dateSuffix}}",
    CTA: 'Make payment'
};
exports.CLASSIC_COVERED = {
    MAIN_TEXT: 'You’re all set!',
    SUB_TEXT: "Your {{currentMonth}} payments are complete \u2014 see you next month."
};
exports.CLASSIC_NOT_COVERED = {
    MAIN_TEXT: "You didn't use Flex this month",
    SUB_TEXT: 'Come back next month to split your rent!'
};
exports.CLASSIC_FAILED_PAYMENT = {
    MAIN_TEXT: 'Your {{paymentLabel}} failed',
    SUB_TEXT: 'Complete your {{paymentLabel}} to continue using Flex. We’ll retry on {{retryDay}}, or you can make your payment now.',
    CTA: 'Pay now'
};
exports.FLEX_ANYWHERE_GET_READY_BEFORE_BP = {
    MAIN_TEXT: 'Welcome, {{firstName}}',
    SUB_TEXT: 'You’re all set up to pay rent with Flex. Starting on {{startDate}}, you can make your 1st payment and use the Flex {{paymentMethod}} to pay your {{bpMonth}} rent.',
    CTA: 'Learn more'
};
exports.FLEX_ANYWHERE_GET_READY_AFTER_BP = {
    MAIN_TEXT: 'Ready to pay your rent?',
    SUB_TEXT: "Make your 1st payment to start the {{bpMonth}} rent process. Then, you'll use the Flex {{paymentMethod}} to submit rent to your property.",
    CTA: 'Make 1st payment'
};
exports.FLEX_ANYWHERE_SUBMIT_RENT = {
    MAIN_TEXT: 'Submit rent to your property',
    SUB_TEXT: 'Enter the Flex {{paymentMethod}} in your property’s portal and pay rent before the 5th (or before rent is due). It may take up to 3 business days for your rent payment to process.',
    CTA: 'Submit rent'
};
exports.FA_PAYMENT_METHOD_STATUS = {
    NOT_READY: { LABEL: 'Not ready', SUBTEXT: 'Available starting {{date}}' },
    ACTION_NEEDED: { LABEL: 'Action needed', SUBTEXT: 'Waiting for 1st payment' },
    READY: { LABEL: 'Ready', SUBTEXT: '{{amount}} available for rent' },
    SUBMITTED: { LABEL: 'Submitted', SUBTEXT: '{{amount}} submitted to your property' },
    PARTIAL_USED: { LABEL: 'Used', SUBTEXT: '{{amountUsed}} rent paid; {{amountLeft}} available' },
    USED: { LABEL: 'Used', SUBTEXT: '{{amount}} rent submission on {{date}}' }
};
exports.FLEX_ANYWHERE_RENT_PAID = {
    MAIN_TEXT: 'Your rent has been paid!',
    SUBTEXT: 'Your next payment of {{amount}} is {{date}}.',
    CTA: 'Make payment'
};
exports.FLEX_ANYWHERE_COVERED = {
    MAIN_TEXT: 'You’re all set!',
    SUBTEXT: 'Your payments to Flex are complete. Come back {{date}} to split your {{month}} rent.'
};
exports.CLASSIC_NO_RENT_POSTED = {
    MAIN_TEXT: 'Your 1st payment will be processed once your rent bill is posted',
    SUB_TEXT: 'We’re still waiting for your property to post your rent bill. When we have the bill, we’ll process your 1st payment, and submit your rent to your property.'
};
exports.CLASSIC_TRACKER_STEPS = ['Get\nready', '1st\npayment', 'Flex pays rent', 'Pay Flex back'];
exports.SLC_CLASSIC_TRACKER_STEPS = ['Get\nready', 'Pay\ndeposit', 'Rent\npayment', 'Pay Flex back'];
exports.SELF_PAY_TRACKER_STEPS = ['Get\nready', '1st\npayment', 'Submit rent', 'Pay Flex back'];
